import React from 'react';
import './AnimatedLogo.css';

const PATH_LEN = 300;

function AnimatedLogo() {
  return (
    <svg className="animated-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <defs>
        <linearGradient id="adl-inf-anim" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#0ea5e9" />
          <stop offset="0.5" stopColor="#6366f1" />
          <stop offset="1" stopColor="#ec4899" />
        </linearGradient>
      </defs>
      <path
        className="animated-logo-path"
        d="M20 50 C20 30, 45 30, 50 50 C55 70, 80 70, 80 50 C80 30, 55 30, 50 50 C45 70, 20 70, 20 50 Z"
        fill="none"
        stroke="url(#adl-inf-anim)"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray={PATH_LEN}
        strokeDashoffset={PATH_LEN}
      >
        <animate
          attributeName="stroke-dashoffset"
          values={`${PATH_LEN};0;0;0`}
          keyTimes="0;0.333;0.888;1"
          dur="9s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="opacity"
          values="1;1;1;0"
          keyTimes="0;0.333;0.888;1"
          dur="9s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
}

export default AnimatedLogo;
